module.exports = __webpack_public_path__ + "static/images/general/resize_area.svg";